import React, { useState } from 'react';
import { InputAdornment, IconButton, TextField } from '@mui/material';
import { Visibility, VisibilityOff, LockOutlined } from '@mui/icons-material';
import { useFormikContext } from 'formik';

const TextFieldPassword = ({ formValue, label, placeholder, ...rest }) => {
    const [showPassword, setShowPassword] = useState(false);
    const formik = useFormikContext();
    const error = formik.touched['password'] && Boolean(formik.errors['password']);
    const value = Boolean(formValue) ? formValue : 'password';

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <TextField
            id={`${value}-form`}
            label={label || "Password"}
            placeholder={placeholder || "Enter your password"}
            variant="outlined"
            type={showPassword ? 'text' : 'password'}
            value={formik.values[value]}
            onChange={formik.handleChange(value)}
            onBlur={formik.handleBlur(value)}
            error={!rest.noValidate && error}
            helperText={formik.touched[value] && formik.errors[value]}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <LockOutlined color="action" />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            fullWidth
            {...rest}
        />
    );
};

export default TextFieldPassword;
